import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Beranda', path: '/' },
    { name: 'Portofolio', path: '/portofolio' },
    { name: 'Blog', path: '/blog' },
    { name: 'Promo', path: '/promo' },
    { name: 'Booking', path: '/booking' },
    { name: 'Tracking', path: '/tracking' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-md z-40">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#FF8A00] to-[#ff9d33] rounded-xl">
              <i className="ri-service-line text-2xl text-white"></i>
            </div>
            <div>
              <h1 className="text-xl font-bold text-[#0B1F3B]">Bastian Digital</h1>
              <p className="text-xs text-gray-600">Service & Solution</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? 'bg-[#FF8A00] text-white'
                    : 'text-gray-700 hover:bg-orange-50 hover:text-[#FF8A00]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href="https://wa.me/6285868360910"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-6 py-3 rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill text-xl"></i>
            WhatsApp
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-[#0B1F3B] hover:bg-gray-100 rounded-lg transition-all cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-3 rounded-lg font-medium transition-all cursor-pointer ${
                    isActive(link.path)
                      ? 'bg-[#FF8A00] text-white'
                      : 'text-gray-700 hover:bg-orange-50 hover:text-[#FF8A00]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://wa.me/6285868360910"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-4 py-3 rounded-xl font-semibold transition-all mt-2 cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
                WhatsApp
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}